import { FC, Fragment } from 'react';

import { Menu } from '@components/base';
import FilterDefinition from '@models/FilterDefinition';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';

type DistinctByMenuItemProps = {
  filterDef: FilterDefinition;
  handleUpdateDistinctBy: (option?: string) => void;
  objPath?: string[];
};

const DistinctByMenuItem: FC<DistinctByMenuItemProps> = ({
  filterDef: { fields, propertyName },
  objPath = [],
  handleUpdateDistinctBy,
}) => {
  const {
    searchQuery: { distinctBy },
  } = useSearchAndFilter();

  const fieldPath = [...objPath, propertyName];
  const fieldName = fieldPath.join('/');

  return fields.length > 0 ? (
    <Fragment>
      {fields.map(field => (
        <DistinctByMenuItem
          filterDef={field}
          handleUpdateDistinctBy={handleUpdateDistinctBy}
          key={field.propertyName}
          objPath={fieldPath}
        />
      ))}
    </Fragment>
  ) : (
    <Menu.Item
      key={fieldName}
      onClick={() => handleUpdateDistinctBy(fieldName)}
      selected={distinctBy === fieldName}
    >
      {fieldName}
    </Menu.Item>
  );
};

export default DistinctByMenuItem;
